import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  FilesizePipe,
  getColumnKey,
  ImageThumbnailComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { NgOptimizedImage } from '@angular/common';
import { AdminMultimediaListFilter } from '../../models/admin-multimedia-list-filter';
import { AdminMultimediaCollectionItem } from '../../models/admin-multimedia-collection-item';

@Component({
  selector: 'app-multimedia-list-custom-cell-template',
  templateUrl: './multimedia-list-custom-cell-template.component.html',
  styleUrl: './multimedia-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FilesizePipe,
    NgOptimizedImage,
    TableBodyNoReferenceCellComponent,
    ImageThumbnailComponent,
  ],
})
export class MultimediaListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminMultimediaCollectionItem, AdminMultimediaListFilter>>();
  public readonly model = input.required<AdminMultimediaCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminMultimediaCollectionItem>;
}
